import { Input } from "@nextui-org/react";
import React, { useContext, useEffect, useState } from "react";
import emailIcon from "../../Assets/auth/sms.svg";
import passIcon from "../../Assets/auth/lock.svg";
import visibleEye from "../../Assets/auth/eye.svg";
import hiddenEye from "../../Assets/auth/eye-slash.svg";
import googleIcon from "../../Assets/auth/social/01.svg";
import appleIcon from "../../Assets/auth/social/04.svg";
import { Link, useNavigate } from "react-router-dom";

import * as Yup from "yup";
import { useFormik } from "formik";
import { AuthContext } from "Context/AuthContext";
import {
  useSignIn,
  GoogleOneTap,
  SignUp,
  useSignUp,
  useClerk,
} from "@clerk/clerk-react";
import axios from "axios";
import { useUser } from "@clerk/clerk-react";
import { Error500Context } from "Context/Error500Context";

const Login = () => {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => setIsVisible(!isVisible);
  const { isLoaded, isSignedIn, user } = useUser();

  const authInfo = [
    { method: "oauth_google", label: "Google" },
    { method: "oauth_apple", label: "Apple" },
  ];

  //integration part

  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const { signUp } = useSignUp();

  const navigate = useNavigate();
  const { signOut } = useClerk();

  const validationSchema = Yup.object({
    email: Yup.string().email("Invalid email").required("Email required"),
    password: Yup.string()
      .matches(
        /(?=.*[a-z])(?=.*[A-Z])(?=.*[\d])(?=.*[!@#$%^&*()_+[\]{};':"\\|,.<>\/?`~\-])/,
        "Password must contain small, capital, number and special character"
      )
      .min(8, "Weak password")
      .max(30, "Password is too long")
      .required("Password required"),
  });

  const loginForm = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema,
    onSubmit: callLogin,
  });

  const { session } = useClerk();

  const { setToken } = useContext(AuthContext);
  const { signIn, setActive } = useSignIn();
  const { setIsServerError } = useContext(Error500Context);

  async function callLogin(reqBody) {
    if (session) {
      session?.end();
      signOut({ redirectUrl: "/login" });
    }
    setErrorMessage("");
    setIsLoading(true);
    setIsDisabled(true);
    try {
      const signInAttempt = await signIn.create({
        identifier: reqBody.email,
        password: reqBody.password,
      });

      // If sign-in process is complete, set the created session as active
      // and redirect the user
      if (signInAttempt.status === "complete") {
        navigate("/loading");
        await setActive({ session: signInAttempt.createdSessionId });

        await axios
          .post("/user", {
            name:
              signInAttempt.userData.firstName +
              " " +
              signInAttempt.userData.lastName,
            email: reqBody.email,
            password: reqBody.email,
            img_url: user.imageUrl,
          })
          .then((response) => {
            const authToken = response.data.response.data.token;
            localStorage.setItem("token", authToken);
            localStorage.setItem("user_email", reqBody.email);
            setToken(authToken);

            axios.defaults.headers.common.Authorization = `Bearer ${authToken}`;
            setIsLoading(false);
            console.log(user.imageUrl);
            // console.log("Login successful, token stored:", authToken);
          })
          .catch((err) => {
            if (err?.response?.status === 500) {
              setIsServerError(true);
              navigate("/server-error");
            } else {
              setErrorMessage(err.errors ? err.errors[0].message : err.message);
            }
          });
      } else {
        // If the status is not complete, check why. User may need to
        // complete further steps.
        setErrorMessage(signInAttempt);
        setIsLoading(false);
      }
    } catch (error) {
      // See https://clerk.com/docs/custom-flows/error-handling
      // for more info on error handling
      setErrorMessage(error.errors ? error.errors[0].message : error.message);
      setIsLoading(false);
    }
    setIsDisabled(false);
  }

  //OAuth

  const signInWith = async (strategy) => {
    return signIn.authenticateWithRedirect({
      strategy,
      redirectUrl: "/sso-callback",
      redirectUrlComplete: "/loading",
    });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="login font-Miranda flex justify-center items-start overflow-x-hidden relative py-1">
      <div className="absolute bottom-0 left-0 sm:w-[450px] w-[80%] h-[412px] bg-authImg1 bg-cover bg-no-repeat z-0"></div>
      <div className="absolute top-[30px] right-0 w-[214px] h-[287px] bg-authImg2 bg-cover bg-no-repeat z-0"></div>
      <div className="container xl:px-44 sm:px-6 px-4 mx-auto relative z-10">
        <div className="box sm:mx-auto sm:w-[585px] w-auto rounded-20px flex flex-col justify-center sm:p-10 p-5 relative z-20 bg-white ">
          <h1 className="font-extrabold text-3xl justify-center text-center mb-12">
            Welcome Back!
          </h1>
          
          
          <div className="login-form mb-6">
            {errorMessage && (
              <div className="text-white bg-cardColor py-3 mb-6 text-center rounded-15px text-sm">
                <span className="bg-clip-text text-transparent bg-mainGradiant font-bold">
                  {errorMessage}
                </span>
              </div>
            )}
            <form onSubmit={loginForm.handleSubmit}>
              <div className="mb-4">
                <Input
                  name="email"
                  type="email"
                  variant="bordered"
                  placeholder="Email"
                  labelPlacement="outside"
                  classNames={{
                    placeholder: "text-[13.81px] font-normal mt-1",
                    input: "py-3 text-sm  border-none",
                  }}
                  onChange={loginForm.handleChange}
                  onBlur={loginForm.handleBlur}
                  value={loginForm.values.email}
                  isInvalid={loginForm.errors.email}
                  errorMessage={
                    loginForm.errors.email && loginForm.touched.email
                      ? loginForm.errors.email
                      : null
                  }
                />
              </div>
              
              <div className="mb-4">
                <Input
                  name="password"
                  variant="bordered"
                  labelPlacement="outside"
                  placeholder="Password"
                  endContent={
                    <button
                      className="focus:outline-none"
                      type="button"
                      onClick={toggleVisibility}
                    >
                      {isVisible ? (
                        // Open eye (visible)
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 text-gray-500">
                          <path strokeLinecap="round" strokeLinejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z" />
                          <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                      ) : (
                        // Closed eye (hidden)
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 text-gray-500">
                          <path strokeLinecap="round" strokeLinejoin="round" d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88" />
                        </svg>
                      )}
                    </button>
                  }
                  type={isVisible ? "text" : "password"}
                  classNames={{
                    label: "text-[13.81px] font-normal opacity-75 mt-1",
                    input: "border-none py-[10.36px]",
                  }}
                  onChange={loginForm.handleChange}
                  onBlur={loginForm.handleBlur}
                  value={loginForm.values.password}
                  isInvalid={loginForm.errors.password}
                  errorMessage={
                    loginForm.errors.password && loginForm.touched.password
                      ? loginForm.errors.password
                      : null
                  }
                />
              </div>
              
              <div className="text-right mb-5">
                <Link
                  to={"/forget-password"}
                  className="text-[#424C9B] text-[13.81px] font-normal hover:opacity-80 transition-opacity"
                >
                  Forgot Password?
                </Link>
              </div>
              
              <button
                type="submit"
                disabled={!(loginForm.isValid && loginForm.dirty) || isDisabled}
                className="w-full bg-mainGradiant h-[44px] text-white text-[15.54px] font-bold rounded-[12.95px]"
              >
                {isLoading ? (
                  <span className="flex gap-2 justify-center items-center">
                    <i className="fa-solid fa-spinner fa-spin text-white"></i>
                  </span>
                ) : (
                  "Log In"
                )}
              </button>
            </form>
          </div>
          
          <div className="font-semibold font-Miranda policy mb-6">
            <p className="text-center text-[13.81px]">
              By logging in, I accept
              <Link
                to="/terms-of-service"
                className="mx-1 bg-clip-text text-transparent bg-mainGradiant font-bold"
              >
                Terms Of Service
              </Link>
              and acknowledge the
              <Link
                to="/privacy-policy"
                className="ms-1 bg-clip-text text-transparent bg-mainGradiant font-bold"
              >
                Privacy Policy
              </Link>
            </p>
          </div>
          
          <div className="continue text-center flex gap-8 items-center justify-center mb-8">
            <span className="bg-cardGrayColor h-[0.86px] flex-grow"></span>
            <span className="text-cardGrayColor text-[13.81px]">
              Or continue with
            </span>
            <span className="bg-cardGrayColor h-[0.86px] flex-grow"></span>
          </div>
          
          <div className="grid grid-cols-2 gap-4 mb-8">
            <button
              onClick={() => signInWith("oauth_google")}
              className="flex items-center justify-center space-x-2 px-4 py-3 border border-gray-300 rounded-xl hover:bg-gray-50 transition-colors duration-200"
            >
              <img src={googleIcon} alt="Google" className="w-5 h-5" />
              <span className="text-sm font-medium text-gray-700">Google</span>
            </button>
            <button
              onClick={() => signInWith("oauth_apple")}
              className="flex items-center justify-center space-x-2 px-4 py-3 border border-gray-300 rounded-xl hover:bg-gray-50 transition-colors duration-200"
            >
              <img src={appleIcon} alt="Apple" className="w-5 h-5" />
              <span className="text-sm font-medium text-gray-700">Apple</span>
            </button>
          </div>
          
          <div className="sign-up text-center text-[13.81px]">
            Don't have an account?
            <Link
              to={"/signup"}
              className="ms-1 bg-clip-text text-transparent bg-mainGradiant relative after:absolute after:left-0 after:right-0 after:bottom-0 after:h-px after:bg-mainGradiant"
            >
              Sign up
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Login;
